<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <add-new-employee title="กรุณากรอกข้อมูลพนักงาน"></add-new-employee>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AddNewEmployee from "./AddNewEmployee";
export default {
  name: "employeeAddNew",
  components: {
    AddNewEmployee,
  },
  data() {
    return {
      model: {
        code: "",
        email: "",
        password: "",
      },
    };
  },
};
</script>
<style>
.search {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
label,
.form-control,
.btn {
  font-size: 1rem !important;
}

h3 {
  font-size: 1.2rem;
}
</style>
